module.exports = __webpack_public_path__ + "media/7-e.735cff54.wav";